export default class AskAboutData {
  constructor(context) {
    this.context = context;
  }

  run({ question, analyticsConversationId, timezone, onSuccess, onError }) {
    this.context.gateways.conversationalAnalytics
      .chat({ question, analyticsConversationId, timezone })
      .then(response => onSuccess(response))
      .catch(error => onError(error));
  }
}
